import { render, staticRenderFns } from "./OrderEditDlg.vue?vue&type=template&id=4c73ff0f&scoped=true"
import script from "./OrderEditDlg.vue?vue&type=script&lang=js"
export * from "./OrderEditDlg.vue?vue&type=script&lang=js"
import style0 from "./OrderEditDlg.vue?vue&type=style&index=0&id=4c73ff0f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c73ff0f",
  null
  
)

export default component.exports